import styled from 'styled-components'

export const PointerContainer = styled.div`
  position: absolute;
  display: ${(props) => (props.show ? "block" : "none")};
  top: 75%;
  left: 50%;
  transform: translateX(-50%);
`;